export default __webpack_public_path__ + "assets/Hazard.a75d.svg";